import { createContext, useContext, useState, useEffect, useCallback } from "react";
import memberApi, { MEMBER_TOKEN_KEY } from "../lib/memberApi";

const MemberAuthContext = createContext(null);

export const MemberAuthProvider = ({ children }) => {
  const [member, setMember] = useState(null); // null = checking, false = logged out, obj = logged in

  const check = useCallback(async () => {
    if (!localStorage.getItem(MEMBER_TOKEN_KEY)) { setMember(false); return; }
    try {
      const { data } = await memberApi.get("/member/me");
      setMember(data);
    } catch (e) {
      localStorage.removeItem(MEMBER_TOKEN_KEY);
      setMember(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await memberApi.post("/member/login", { email, password });
    localStorage.setItem(MEMBER_TOKEN_KEY, data.token);
    await check();
    return data.member;
  };

  const setSession = async (token) => {
    localStorage.setItem(MEMBER_TOKEN_KEY, token);
    await check();
  };

  const logout = () => {
    localStorage.removeItem(MEMBER_TOKEN_KEY);
    setMember(false);
  };

  return (
    <MemberAuthContext.Provider value={{ member, login, setSession, logout, refresh: check }}>
      {children}
    </MemberAuthContext.Provider>
  );
};

export const useMemberAuth = () => useContext(MemberAuthContext);
